module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAECAYAAADfyyz1AAAAAXNSR0IArs4c6QAAAS5JREFUOE9lU9txA0EIk7gSElflJpLK/J9HGRlPWsklLRwZAbuL7fu4fYBACJb+9XaGbRcnTqQ5SIAG1y72dJ117/qbaYnz8IW+woWfsA9+wi8claOdJ0ZxkLl6zMWt7LLSPP0sKShn7Ds//h60V/r14wfg8yKegQbYs9pWWNpYAkTxQ4xOnMHkJqkXoRmfsxgPxyIuwqkzoxDaJruEqeK1VFMqp0euUTQBs6Begu306/sO2lPIq4Dln10MmabCQfymU9VpocSh2wS21p1mU5yjSN8TDsEDW1MVXWqCVVwpcZtTE5Kih0ghVvnQdvr35xkHLiBO4H2hNa5zRJaSQ3EVk2O3pfpz/Bd2jH2N4iKuiybAfBrz+Xg9gRT0cerqLkY9i8tc2fh4gsCf2/byD5/Bb81JC17dAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(58).png
// module id = KjVKr
// module chunks = 1